import { IFileType } from 'types'

export const formatPartitionKey = (fileType: IFileType, region: string | undefined, year: string | undefined): string => {
  if (fileType === IFileType.Holiday) return `${region as string}_${year as string}`
  else return fileType as string
}
